// extracted by mini-css-extract-plugin
module.exports = {"component":"typeahead-dropdown-component--ufuJv"};